import request from '@/utils/request'

export function pageOrderMasterBondFlow(query) {
  return request({
    url: '/order/order-master-bond-flow/page',
    method: 'get',
    params: query
  })
}

export function getOrderMasterBondFlow(data) {
  return request({
    url: '/order/order-master-bond-flow/detail',
    method: 'get',
    params: data
  })
}

export function addOrderMasterBondFlow(data) {
  return request({
    url: '/order/order-master-bond-flow/add',
    method: 'post',
    data: data
  })
}

export function updateOrderMasterBondFlow(data) {
  return request({
    url: '/order/order-master-bond-flow/edit',
    method: 'post',
    data: data
  })
}

export function delOrderMasterBondFlow(data) {
  return request({
    url: '/order/order-master-bond-flow/delete',
    method: 'post',
    data: data
  })
}
